import React, { useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { formatNumber, getDatebookImageFolder } from '../../helpers/utils';
import { CartContext } from '../../contexts/CartContext';

const ProductItem = ({ product }) => {
    const history = useHistory();
    const { addProduct } = useContext(CartContext);

    const handleBuyNow = (evt) => {
        evt.preventDefault();
        addProduct(product, 1);
        history.push('/cart');
    }

    return (
        <div className="card card-body">
            <Link to={`/product/${product.id}`} style={{ textDecoration: 'none' }}>
                <img style={{ display: "block", margin: "0 auto 10px", maxHeight: "200px" }} className="img-fluid"
                    src={`/img/${getDatebookImageFolder(product.category)}/${product.thumbnailImage}`} alt="" />
                <h3 className="my-2 text-center">{product.displayName}</h3>
                <h4 className="text-center">{formatNumber(product.price)}</h4>
            </Link>
            <div className="text-center">
                <Link to={`/product/${product.id}`} className="btn btn-link btn-sm mr-2">Details</Link>
            </div>
            <div style={{ marginTop: "10px" }}>
                <Link
                    to={'/cart'}
                    onClick={handleBuyNow}
                    style={{
                        display: "block",
                        margin: "0 auto",
                        backgroundColor: "#FFD814",
                        color: "#111",
                        fontWeight: "bold",
                        padding: "10px 20px",
                        borderRadius: "8px",
                        textDecoration: "none",
                        boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
                        width: "80%",
                        textAlign: "center"
                    }}
                >
                    Buy Now!
                </Link>
            </div>
        </div>
    );
}

export default ProductItem;